import React from 'react';
import AddToCalendar from 'react-add-to-calendar';
import './AddToCal.css';
 
const AddToCal = ({ event, buttonText }) => {
  return <AddToCalendar event={event} buttonLabel={buttonText} />;
}

export default AddToCal;